module.exports = __webpack_public_path__ + "static/img/fangshou.234d6c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/test/fangshou.jpg
// module id = xt3A
// module chunks = 1